import { TCText } from "../../../components/TCText/TCText";
import { Colors } from "../../../utils/colors";
import UltraMatchLogo from "../../../assets/ultra_match_logo.png";
import WhiteVideo from "../../../assets/white_video.png";
import { formatDate, formatDateTime } from "../../../utils/utils";
import { useMemo } from "react";

type props = {
  matchDate?: string;
  showVideoIndicator?: string;
};
export const ScoreSectionHeader: React.FC<props> = ({
  matchDate,
  showVideoIndicator,
}) => {
  const time = useMemo(
    () => (matchDate ? formatDateTime(matchDate) : "-"),
    [matchDate]
  );
  return (
    <div
      style={{
        width: "100%",
        backgroundColor: Colors.darkBrown,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 8,
        paddingBottom: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <img
          src={UltraMatchLogo}
          alt=""
          style={{
            width: 32,
            height: 32,
            objectFit: "cover", // Ensures the image covers the area
          }}
        />
        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <TCText
            value="Played on"
            style={{ fontSize: 12, fontWeight: 400, color: Colors.white }}
          />
          <TCText
            value={`${formatDate(matchDate ?? "")}, ${time.split("-")[1]}`}
            style={{ fontSize: 12, fontWeight: 600, color: Colors.white }}
          />
        </div>
      </div>
      {showVideoIndicator && (
        <img
          src={WhiteVideo}
          alt=""
          style={{
            width: 16,
            height: 16,
            objectFit: "contain", // Ensures the image covers the area
          }}
        />
      )}
    </div>
  );
};
